import { render, staticRenderFns } from "./Editor4.vue?vue&type=template&id=e95fc9c8&"
import script from "./Editor4.vue?vue&type=script&lang=js&"
export * from "./Editor4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports